/**
 * Game-related translations for Portuguese language
 * This file contains translations for game mechanics, stages, and end reasons
 */
export default {
  game: {
    winner: 'Vencedor',
    evil: 'mal',
    good: 'bem',
    stage: 'estágio',
    voteStage: 'Estágio de votação',
    voting: 'votação',
    excalibur: 'excalibur',
    'team building': 'formação de equipe',
    mission: 'missão',
    initialization: 'inicialização',
    'lady of lake': 'dama do lago',
    'check loyalty': 'verificar lealdade',
    'witch loyalty': 'lealdade da bruxa',
    'announce loyalty': 'anunciar lealdade',
    'give card': 'dar carta',
    'lead to victory': 'liderar para a vitória',
    'restore honor': 'restaurar honra',
    'king returns': 'o rei retorna',
    'play card': 'jogar carta',
    'reveal loyalty': 'revelar lealdade',
    'we found you': 'nós te encontramos',
    ambush: 'emboscada',
    end: 'fim',
    lancelots: 'lancelots',
    witch: 'bruxa',
    assassinate: 'assassinar',
    hidden: 'oculto',
    historyMode: 'Modo história',
    gameIsEnded: 'O jogo terminou',
    rolesAndAddons: 'Papéis e complementos',
  },
  endReason: {
    manualy: 'O jogo foi finalizado manualmente',
    evilTeamMissions: 'O time do mal falhou em 3 missões',
    goodTeamMissions: 'O time do bem teve sucesso em 3 missões',
    missMerlin: 'O time do mal tentou matar Merlin, mas errou',
    missGuinevere: 'O time do mal tentou matar Guinevere, mas errou',
    missLovers: 'O time do mal tentou matar os Amantes, mas errou',
    missCleric: 'O time do mal tentou matar o Clérigo + 1, mas errou',
    killCleric: 'O time do mal matou o Clérigo + 1',
    killGuinevere: 'O time do mal matou Guinevere',
    killLovers: 'O time do mal matou os Amantes',
    killMerlin: 'O time do mal matou Merlin',
    rejectedVote: 'O time do mal sabotou a votação',
  },
};
